import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const CardWrapperStyled = styled.div `
  padding: 24px 0;
  background-color: ${colorCoreWhite1000};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 32px 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px 0;
  }
`;
export const DescriptionStyled = styled(RegularTextLevel3) `
  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
